import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { RoomService } from '@zaoblako/web/core/services/catalog/room.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-room-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './room-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomSingleSelectComponent implements OnInit {
  @Input() public rooms: RoomFindInterface[] = [];
  public loading = false;

  @Input() public selectedRoom: RoomFindInterface;
  @Output() public selectedRoomChange = new EventEmitter<RoomFindInterface>();

  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public constructor(
    private readonly roomService: RoomService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled
    ) {
      this.loading = true;
      this.roomService.findAll().subscribe({
        next: (rooms) => {
          this.rooms = rooms;
          this.loading = false;
          this.cdRef.markForCheck();
        },
        error: () => {
          this.loading = false;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
